import { createClient } from "@easyshot/shared";

/** 同源相对路径；App 端会传服务器地址进去 */
export const api = createClient("");
